module.exports = __webpack_public_path__ + "static/media/stfgraphic.5d48ab5e.png";